<div class="banner justify-content-center" role="banner">
  <h1 class="text-white">{{ 'savings.page.title' | translate }}</h1>
</div>

<fgb-endurance-zone></fgb-endurance-zone>
